import isPlainObject from 'lodash.isplainobject'

const getKeyType = (key: any, row): string => {
  const value = row[key]
  switch (true) {
    case Array.isArray(value):
      return 'array'
    case isPlainObject(value):
      return 'object'
    default:
      return 'primitive'
  }
}

const getKeyData = (keyLabels, rows) => {
  const keyData = {}
  keyLabels.forEach((item) => {
    keyData[item.key] = {
      key: item.key,
      label: item.label,
      type: getKeyType(item.key, rows[0])
    }
  })

  return keyData
}

export {getKeyData, getKeyType}
